var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h3', [_vm._v("Fix Experiments")]), _c('el-form', {
    attrs: {
      "model": _vm.item,
      "label-width": "120px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Commit SHA",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.item.id
    },
    model: {
      value: _vm.item.sha,
      callback: function ($$v) {
        _vm.$set(_vm.item, "sha", $$v);
      },
      expression: "item.sha"
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.hotfix,
      expression: "loading.hotfix"
    }],
    attrs: {
      "slot": "append",
      "type": "primary"
    },
    on: {
      "click": _vm.deployFix
    },
    slot: "append"
  }, [_vm._v(" Deploy fix ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }